<template>
  <div>
    <div class="page-header"><h2>Research &amp; Business Development</h2></div>
    <section class="page-content">
      <!-- individual elements card -->
      <div v-for="p in programs" :key="p.id" class="card">
        <!-- card head -->
        <div class="card-head">
          <h3 style="margin: .5rem 0">{{ p.title }}</h3>
          <button v-if="!p.clicked" @click.prevent="p.clicked = !p.clicked">
            See More
          </button>
        </div>
        <!-- card body  -->
        <div class="card-body" v-if="p.clicked">
          <p v-html="p.description"></p>
        </div>
        <!-- card footer  -->
        <div class="card-footer" v-if="p.clicked">
          <button
            class="btn btn-outline-dark"
            @click.prevent="p.clicked = !p.clicked"
          >
            Hide info
          </button>
        </div>
      </div>
    </section>
    <!-- use map array modifier to select only titles -->
    <ServiceForm
      :options-list="programs.map(p => p.title)"
      id="form"
    ></ServiceForm>
  </div>
</template>

<style scoped>
/* .page-content */
.page-content {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1rem;
}
div.card {
  grid-column: span 1;
  border-radius: 1rem;
  box-shadow: 2px 8px 30px lightgrey;
}
.card-head {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom-style: solid;
  border-bottom: 1px;
  padding: 1rem;
}
.card-head button {
  background-color: rgba(0, 0, 0, 0);
  color: var(--tetiary-color);
  border-width: 0;
}
.card-body {
  border-width: 2px 0;
  padding: 1rem;
}
.card-footer {
  background-color: var(--secondary-color);
  padding: 0.5rem 0;
  padding: 1rem;
}
@media only screen and (max-width: 998px) {
  div.card {
    grid-column: span 2;
  }
}
</style>

<script>
import ServiceForm from "./ServiceForm.vue";
export default {
  components: {
    ServiceForm
  },
  data() {
    return {
      programs: [
        {
          title: "Feasibility Studies",
          description:
            "We understand the need to ascertain the cost, viability and profitability of your proposed project, hence we are poised to give you a reliable research based study clearly analyzing the strengths and deficits in order to save you money, resources and time. This will help you make informed decision on the technical feasibility and profitability of such projects.",
          clicked: false
        },
        {
          title: "Business & Financial Plan",
          description:
            "If you engage us to write your business and financial plan, we will clearly highlight your companys. <ul><li>Value Proposition</li><li>Critical Success Factors</li><li>Industry Analysis</li><li>Marketing Plan</li><li>SWOT and PEST Analysis</li><li>Competition Analysis</li><li>Production / Operational Plan</li><li>Organizational & Personnel Plan</li><li>Business Risks & Mitigation Strategies</li><li>Strategic Growth Plans; Projected growth rates</li><li>Revenue and Seasonality Estimates</li><li>Debt Amortization</li><li>Working Capital Schedule</li><li>PPE and Depreciation schedule</li><liIncome Statement></li><li>Cash flow Projections</li><li>Balance Sheet Projections etc.</li></ul>",
          clicked: false
        },
        {
          title: "Business Growth Strategies",
          description:
            "Our team of professionals will help you with strategies on product development and expansion, market penetration, diversification, cost reduction,  brand differentiation, mergers and acquisition.",
          clicked: false
        },
        {
          title: "Industry Data Generation",
          description:
            "If you need professionals to help you with marketing statistics, trends, specific 	contact lists, data collection 	and analysis etc. we are ready to wow you.",
          clicked: false
        },
        {
          title: "Incubator/Accelerator Curriculum Designs and Facilitation",
          description:
            "If you need innovative and research based curriculum for your Incubator/Accelerator programs then we are the go to organization to give you that top notch service. In addition to designing your curriculum we can also help you facilitate the program in the most world class and professional manner.",
          clicked: false
        }
      ],
      clicked: false
    };
  }
};
</script>
